import React, { useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import usePersistedFilters from "../hooks/usePersistedFilters";
import usePersistedPageSize from "../hooks/usePersistedPageSize";
import AddressesExPnFilters from "../components/Reports/AddressesExPn/AddressesExPnFilters";
import AddressesExPnButtons from "../components/Reports/AddressesExPn/AddressesExPnButtons";
import AddressesExPnTable from "../components/Reports/AddressesExPn/AddressesExPnTable";
import PaginationComponent from "../components/PaginationComponent";
import ReportIcon from "../assets/images/emerging_market_solutions_rgb_red.svg";
import "../assets/styles/addresses.scss";
import api from "../services/httpClient";

const ReportsAddressesExPn = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = usePersistedPageSize("addressesExPn", 20);
  const { filters, handleFilterChange: persistFilter, clearFilters, hasActiveFilters } = usePersistedFilters("addressesExPn", { mode: "EX" });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [sortConfig, setSortConfig] = useState({ key: "Terminal", direction: "asc" });

  const [data, setData] = useState({
    items: [],
    totalRecords: 0,
    totalPages: 0,
    pageNumber: 1,
    pageSize: itemsPerPage,
  });

  const fetchData = React.useCallback(
    async (
      pageNumber = currentPage,
      pageSize = itemsPerPage,
      filtersToApply = appliedFilters,
      sortConfigToApply = sortConfig
    ) => {
      try {
        const params = {
          pageNumber,
          pageSize,
          SortBy: sortConfigToApply.key,
          SortDirection: sortConfigToApply.direction,
          ...filtersToApply,
        };

        const response = await api.get(`/AddressExPn/List`, { params });

        setData({
          items: Array.isArray(response.data.items) ? response.data.items : [],
          totalRecords: response.data.totalRecords || 0,
          totalPages: response.data.totalPages || 0,
          pageNumber: response.data.pageNumber || 1,
          pageSize: response.data.pageSize || itemsPerPage,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        setData({
          items: [],
          totalRecords: 0,
          totalPages: 0,
          pageNumber: 1,
          pageSize: itemsPerPage,
        });
      }
    },
    [currentPage, itemsPerPage, appliedFilters, sortConfig]
  );

  React.useEffect(() => {
    fetchData();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = (field, value) => {
    persistFilter(field, value);
    const updatedFilters = { ...filters, [field]: value };
    setAppliedFilters(updatedFilters);
    fetchData(1, itemsPerPage, updatedFilters);
    setCurrentPage(1);
  };

  const handleSearch = () => {
    setAppliedFilters(filters);
    fetchData(1, itemsPerPage, filters);
    setCurrentPage(1);
  };

  const handleSortChange = (newSortConfig) => {
    setSortConfig(newSortConfig);
    fetchData(currentPage, itemsPerPage, appliedFilters, newSortConfig);
  };

  return (
    <div className="addresses-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <img
              src={ReportIcon}
              alt="Reports"
              style={{ width: "30px", height: "30px" }}
            />
          </Col>
          <Col>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Lista tras, z podziałem na terminal
            </h3>
          </Col>
          <Col xs="auto">
            <AddressesExPnButtons onSearch={handleSearch} filters={filters} />
          </Col>
        </Row>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <AddressesExPnFilters onFilterChange={handleFilterChange} onSearch={handleSearch} filters={filters} />
          </Col>
          <Col className="flex-grow-1" />
        </Row>
        <Row className="justify-content-end mb-3">
          <Col xs="auto">
            <Button
              variant={hasActiveFilters ? "success" : "outline-secondary"}
              size="sm"
              className="me-3"
              onClick={() => { clearFilters(); const init = { mode: "EX" }; setAppliedFilters(init); fetchData(1, itemsPerPage, init); setCurrentPage(1); }}
            >
              Wyczyść filtry
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <AddressesExPnTable
              data={data.items}
              onSortChange={handleSortChange}
              mode={filters.mode || "EX"}
            />
          </Col>
        </Row>
        <Row className="align-items-center mt-4">
          <PaginationComponent
            itemsPerPage={data.pageSize}
            dataCount={data.items.length}
            totalCount={data.totalRecords}
            totalPages={data.totalPages}
            pageNumber={currentPage}
            onPageChange={(page) => {
              setCurrentPage(page);
              fetchData(page, itemsPerPage);
            }}
            onItemsPerPageChange={(pageSize) => {
              const size = Number(pageSize);
              setItemsPerPage(size);
              setCurrentPage(1);
              fetchData(1, size);
            }}
            itemsPerPageOptions={[20, 100, 500, 1000, 5000]}
          />
        </Row>
      </Container>
    </div>
  );
};

export default ReportsAddressesExPn;


